import React from 'react'
import { SelectInput } from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { ImageGrid, ImageGriditemBar, ImageGridImage } from '../../components/image-grid'
import { ListBase } from '../../components/base'

const HerobannerListFilter = [
  <SelectInput
    key={0}
    label={`${COMMON_FIELDS}.status.label`}
    source='is_active'
    choices={[
      { id: 'true', name: `${COMMON_FIELDS}.status.choices.active` },
      { id: 'false', name: `${COMMON_FIELDS}.status.choices.inActive` },
    ]}
  />,
]

const HerobannersList = (): JSX.Element => {
  return (
    <ListBase filters={HerobannerListFilter} sort={{ field: 'create_at', order: 'DESC' }}>
      <ImageGrid>
        <ImageGridImage source={'image_desktop.full_path'} />
        <ImageGriditemBar activeSource='is_active' />
      </ImageGrid>
    </ListBase>
  )
}

export default HerobannersList